import { ITitleWithSort } from '@pra-vendas-themes/interfaces/ITitleWithSort';

import { useComponentsTheme } from 'hooks/useComponentsTheme';

import { WithChildren } from 'types/WithChildren';

export const TitleWithSort: WithChildren<ITitleWithSort> = ({
  children,
  ...props
}) => {
  const { TitleWithSort: TitleWithSortTheme } = useComponentsTheme();

  return <TitleWithSortTheme {...props}>{children}</TitleWithSortTheme>;
};
